module.exports = __webpack_public_path__ + "img/129.21bf0a7d.jpg";